/* ============================================
   A Romance Court — Button Glitch Init
   File: assets/arc-global.js
   Sets data-text only on <a> link buttons
   (glitch is not applied to form buttons).
   ============================================ */
(function () {
  var sel = 'a.button, a.button-secondary';

  function initButtons() {
    document.querySelectorAll(sel).forEach(function (btn) {
      var text = btn.textContent.replace(/\s+/g, ' ').trim();
      if (text) btn.setAttribute('data-text', text);
    });
  }

  initButtons();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  }
  window.addEventListener('load', initButtons);
  document.addEventListener('shopify:section:load', initButtons);

  var observer = new MutationObserver(function (mutations) {
    var shouldRun = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (
          (n.matches && n.matches(sel)) ||
          (n.querySelector && n.querySelector(sel))
        );
      });
    });
    if (shouldRun) initButtons();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
